export default "__VITE_ASSET__CPX56ysC__"